<template>
  <v-container>
    <div class="d-flex justify-space-between">
      <!-- <router-link :exact="true" :disabled="permitObj.add" :event="permitObj.add ? 'click' : ''"
        :to="{ name: 'AddTutor' }" active-class="" class="profile-link">
        <v-btn color="#6A158E" v-if="permitObj.add" dark>+ Add Tutor</v-btn>
      </router-link> -->

      <router-link :exact="true" :disabled="permitObj.t_add" :event="permitObj.t_add ? 'click' : ''"
        :to="{ name: 'AddTutor' }" active-class="" class="profile-link">
        <v-btn color="#6A158E" v-if="permitObj.t_add" dark>+ Add Tutor</v-btn>
      </router-link>


      <bread-crumbs :items="breadItems"></bread-crumbs>
    </div>

    <div class="nmt-1">
      <tutor-table :perm="permitObj"></tutor-table>
    </div>
  </v-container>
</template>

<script>
import BreadCrumbs from "../../../components/BreadCrumbs";
import TutorTable from "../../../components/tutors/TutorTable.vue";
import { getPermitObjects } from '../../../utils/allowedPermissions'

export default {
  name: "Tutors",
  components: { TutorTable, BreadCrumbs },
  data() {
    return {
      permitObj: {},
      breadItems: [
        {
          text: "Dashboard",
          disabled: false,
          href: "/",
          to: {
            name: "DashBoard",
          },
        },
        {
          text: "Tutors",
          disabled: true,
          to: {
            name: "Tutors",
          },
        },
      ],
    };
  },
  methods: {
    getPermittedArray() {
      let links = this.$store?.getters?.permissions;
      let pathName = "Tutors";
      this.permitObj = getPermitObjects(links, pathName)
    }
  },
  mounted() {
    this.getPermittedArray();
  }
};
</script>

<style scoped>
</style>
